import { ReactElement } from "react";

import { Factors } from "types/factor/factor";

import TotpQrCodeProvider from "../../providers/TotpQrCodeProvider";

import MfaFactor from "../mfaFactor/MfaFactor";

import styles from "./factor-list.module.css";

const FactorList = ({
  title,
  factors,
}: {
  title?: string;
  factors: Factors;
}): ReactElement => {
  return (
    <>
      {title && <h3>{title}</h3>}

      <ul className={styles.listContainer}>
        {factors.map((factor) => {
          return (
            <li className={styles.listItem} key={factor.key}>
              <TotpQrCodeProvider>
                <MfaFactor factor={factor} />
              </TotpQrCodeProvider>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default FactorList;
